import React from "react";
import LanguageOption from "../../common/LanguageOption";

const LanguageSwitcher = () => {
  return (
    <div className="bg-[#FFFFFF] w-full h-[801px] text-[#000000]">
      <h1 className="text-[16px] md:text-[20px] font-semibold">
        Language Settings
      </h1>
      <p className="text-[14px] text-[#475467] font-medium md:text-[16px] mt-2 md:mt-3">
        Select language that suits you best
      </p>

      <hr className="mt-[10px] mb-[20px] md:my-6 w-full h-[1px] bg-[#000000] bg-opacity-[25%]" />

      <div className=" md:max-w-[580px]">
        <p className="text-[12px] text-[#475467] font-medium md:text-[16px] mb-5">
          Select your preferred Language.
        </p>
        <LanguageOption />
      </div>
    </div>
  );
};

export default LanguageSwitcher;
